import { render } from "./XIconSolidBanknoteArrowUp.vue?vue&type=template&id=994944fa"
import script from "./XIconSolidBanknoteArrowUp.vue?vue&type=script&lang=js"
export * from "./XIconSolidBanknoteArrowUp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidBanknoteArrowUp.vue"]])

export default __exports__